import React, { useState, useEffect } from "react";
import { Button, notification, Modal } from "antd";
import { Redirect } from "react-router-dom";

import axios from "axios";

import Header from "../../../User/Header";
import ModalLoading from "../../../shared/components/Modals/ModalLoading";
import NotasTurmaOrigem from "./NotasTurmaOrigem";
import NotasTurmaDestino from "./NotasTurmaDestino";

const confirm = Modal.confirm;

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const ImportarNotas = () => {
    const [nomeAluno, setNomeAluno] = useState("");
    const [turmaOrigem, setTurmaOrigem] = useState(null);
    const [turmaDestino, setTurmaDestino] = useState(null);
    const [disciplinasDestino, setDisciplinasDestino] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalLoading, setModalLoading] = useState(true);
    const [modalMessage, setModalMessage] = useState("A preparar notas para a importação...");

    const [redirect, setRedirect] = useState(false);
    const [redirectLink, setRedirectLink] = useState("");

    // sessionStorage.setItem("alunoId", 9596);
    // sessionStorage.setItem("turmaOrigemId", 36222);
    // sessionStorage.setItem("turmaDestinoId", 36234);

    const carregarInfosAluno = () => {
        const alunoId = sessionStorage.getItem("alunoId");

        axios({
            method: "get",
            url: "/api/colaboradores/utilizador-nome",
            params: {
                utilizadorid: alunoId
            }
        })
            .then(response => {
                setNomeAluno(response.data);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar informações do aluno.");
            });
    };

    const prepararNotasParaImportacao = () => {
        const alunoId = sessionStorage.getItem("alunoId");
        const turmaOrigemId = sessionStorage.getItem("turmaOrigemId");
        const turmaDestinoId = sessionStorage.getItem("turmaDestinoId");

        if (!alunoId || !turmaOrigemId || !turmaDestinoId) {
            openNotificationWithIcon("warning", "Aviso", "Faltam dados para iniciar a importação");
            return;
        }

        axios({
            method: "get",
            url: "/api/importacoes/preparar-notas",
            params: {
                alunoId,
                turmaOrigemId,
                turmaDestinoId
            }
        })
            .then(response => {
                var resultado = response.data.data;
                setTurmaOrigem(resultado[0]);
                setTurmaDestino(resultado[1]);
                setModalLoading(false);
            })
            .catch(error => {
                setLoading(false);
                openNotificationWithIcon("error", "Erro", error.response?.data?.errorMessage);
                setModalLoading(false);
            });
    };

    const guardarNotasImportadas = () => {
        confirm({
            title: "Confirmar importação de notas",
            content: "Tem a certeza que pretende importar as notas para a turma de destino?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                setModalMessage("A importar notas... Aguarde um momento.");
                setModalLoading(true);

                const alunoId = sessionStorage.getItem("alunoId");

                axios({
                    method: "post",
                    url: "/api/importacoes/guardar-notas-importadas",
                    params: {
                        alunoId
                    },
                    data: disciplinasDestino
                })
                    .then(() => {
                        openNotificationWithIcon("success", "Sucesso", "Notas importadas com sucesso para a turma de destino.");
                        setModalLoading(false);
                        voltarHome();
                    })
                    .catch(error => {
                        openNotificationWithIcon("error", "Erro", error.response?.data?.errorMessage);
                        setModalLoading(false);
                    });
            }
        });
    };

    const voltarHome = () => {
        ["alunoId", "turmaOrigemId", "turmaDestinoId"].forEach(key => sessionStorage.removeItem(key));

        const backUrl = sessionStorage.getItem("backUrl");
        setRedirectLink(backUrl ?? "/utilizador");
        setRedirect(true);
    };

    useEffect(() => {
        carregarInfosAluno();
        prepararNotasParaImportacao();
    }, []);

    if (redirect) return <Redirect to={redirectLink} />;

    return (
        <>
            <Header titulo={`Importação de notas de ${nomeAluno}`} />
            <div className="container container-body">
                <div className="bloco-conteudo">
                    <div className="multi-blocos">
                        <NotasTurmaOrigem turma={turmaOrigem} />
                        <NotasTurmaDestino turma={turmaDestino} setDisciplinasDestino={setDisciplinasDestino} />
                    </div>
                    <div style={{ marginTop: 40, display: "flex", justifyContent: "left", gap: 10 }}>
                        <Button type="default" onClick={voltarHome}>
                            Cancelar
                        </Button>
                        <Button type="primary" onClick={guardarNotasImportadas}>
                            Confirmar importação
                        </Button>
                    </div>
                </div>
            </div>
            <ModalLoading visible={modalLoading} text={modalMessage} />
        </>
    );
};

export default ImportarNotas;
